<div class="container-fluid bg-white h-100">
  @if (loaded) {
    <div class="row h-100">
      <div class="col-md-12 scrollbar-visible pr-0">
        <cdk-virtual-scroll-viewport class="h-100" itemSize="100">
          <div class="row m-0">
            <div class="col-sm-12 text-center">
              <p class="page-header"><span>{{'pages.catalogIndex.header' | translate | uppercase}}</span></p>
            </div>
          </div>
          <div class="align-items-center-middle">
            @if (isCopyingConfiguration()) {
              <div class="copying-container">
                <div class="copying-label"> {{ 'SELECT_TO_COPY' | translate }}
                  <span class="copying-label-cancel" (click)="cancelCopyingConfiguration()">{{'ANNULLA' | translate}}</span>
                </div>
              </div>
            }
<!--            <div class="flex-end-padding">-->
<!--              <button (click)="catalogList()" class="btn catalog-list" type="button">-->
<!--                <img class="pb-2" src="assets/img/sedia_mattone.svg">-->
<!--              </button>-->
<!--              <button (click)="productIndex()" class="btn product-index" type="button">-->
<!--                {{ 'INDEX' | translate }}-->
<!--              </button>-->
<!--            </div>-->
          </div>
          <div class="row m-0 justify-content-center iubenda-padding">
            <div class="px-lg-5 catalog text-center">
              <div class="col-md-12 model index-container pt-5">
                @for (catalog of catalogs; track catalog) {
                  <div class="model-el">
                    <h2 (click)="catalogDetail(catalog.categoryId)" class="model-header">{{catalog.categoryName}}</h2>
                    @for (product of catalog?.productModels; track product) {
                      <p (click)="modelDetail(product.id, catalog.categoryId)"
                      class="model-name">{{product.name}}</p>
                    }
                  </div>
                }
              </div>
            </div>
          </div>
          @if (!loaded) {
            <app-visionnaire-loader class="ipe:w-full" />
          }
        </cdk-virtual-scroll-viewport>
      </div>
    </div>
  }
</div>
@if (!loaded) {
  <app-visionnaire-loader class="ipe:w-full" />
}
